import type { SerializedEditorState } from "lexical";

import { copyAndNotify } from "~/components/notifications/notification";
import { MarkdownIcon, StandardTextIcon } from "~/icons";
import { DropdownMenuItemKind } from "~/shared/enums";
import type { DropdownMenuItem } from "~/shared/types";
import { getText, isLexicalStateEmpty } from "~/utils/common";

import { convertToMarkdown } from "./transformers";

export const getCopyItems = (
  description: string,
  content: SerializedEditorState | null | undefined
): DropdownMenuItem[] => {
  const disabled = !content || isLexicalStateEmpty(content);
  return [
    {
      title: "Copy as markdown",
      kind: DropdownMenuItemKind.BUTTON,
      icon: MarkdownIcon,
      disabled,
      onClick: () => {
        if (!content) {
          return;
        }
        copyAndNotify(description, convertToMarkdown(content));
      },
    },
    {
      title: "Copy as text",
      kind: DropdownMenuItemKind.BUTTON,
      icon: StandardTextIcon,
      disabled,
      onClick: () => {
        if (!content) {
          return;
        }
        copyAndNotify(description, getText(content));
      },
    },
  ];
};
